// extracted by mini-css-extract-plugin
export var dateLabel = "_2z-0";
export var dateLabelError = "_2z-1";
export var fullWidth = "_2z-2";
export var smaller = "_2z-3";